import {useState} from "react";
import SidebarLinkGroupLink from "./SidebarLinkGroupLink.jsx";

const KEEP_OPEN = false;

export default function SidebarLinkGroup({group, setSidebarExpanded, onLockedClick}) {

    let current = group['is_current'];

    let [opened, setOpened] = useState(current || KEEP_OPEN);

    return (
        <li className={`px-3 py-2 rounded-lg mb-0.5 last:mb-0 ${current && 'bg-violet-500/10 dark:bg-violet-500/20'}`}>
            <a href="#"
               aria-label={group['name']}
               aria-expanded={opened}
               className={`
                    block !text-gray-800 dark:!text-white truncate transition duration-150
                    ${current ? 'hover:!text-gray-800 dark:hover:!text-white' : 'hover:!text-violet-500 dark:hover:!text-violet-400'}
               `}
               onClick={(e) => {
                   e.preventDefault();
                   setOpened((!opened) || KEEP_OPEN);
                   setSidebarExpanded(true);
               }}
            >
                <div className="flex items-center justify-between">
                    <div className="ico-text flex items-center">
                        <div className={`icon w-5 text-center ${current ? 'text-violet-500' : 'text-gray-400'}`}>{group['icon']}</div>
                        <span
                            className="text-sm font-medium ml-2 lg:hidden lg:sidebar-expanded:inline 2xl:inline"
                        >
                            {group['name']}
                        </span>
                    </div>
                    {/* Icon */}
                    {!KEEP_OPEN &&
                        <div className="flex shrink-0 arrow lg:hidden lg:sidebar-expanded:flex 2xl:flex">
                            <svg
                                className={`w-3 h-3 shrink-0 ml-1 fill-current text-gray-400 ${opened && 'rotate-180'}`}
                                viewBox="0 0 12 12"
                            >
                                <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z"/>
                            </svg>
                        </div>
                    }
                </div>
            </a>
            <div className="lg:hidden lg:sidebar-expanded:block 2xl:block">
                <ul className={`submenu pl-7 mt-1 ${!opened && 'hidden'}`}>
                    {group['routes'].map((route, index) =>
                        <SidebarLinkGroupLink route={route} onLockedClick={onLockedClick} key={index + route['name']}/>
                    )}
                </ul>
            </div>
        </li>
    );
}
